import { render } from "./home-banner-skeleton.vue?vue&type=template&id=64946cdc&scoped=true"
import script from "./home-banner-skeleton.vue?vue&type=script&lang=js"
export * from "./home-banner-skeleton.vue?vue&type=script&lang=js"

import "./home-banner-skeleton.vue?vue&type=style&index=0&id=64946cdc&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64946cdc"]])

export default __exports__